import { TokenCurrency } from "@/api/supporter";
import { seo } from "@/utils/seo";
import { createFileRoute } from "@tanstack/react-router";
import { fallback, number, object, optional, picklist, pipe, toMinValue } from "valibot";

export const Route = createFileRoute("/supporter/$supporterId/financial-reports/transactions")({
  validateSearch: object({
    page: fallback(pipe(optional(number(), 1), toMinValue(1)), 1),
    "page-size": fallback(pipe(optional(number(), 100), toMinValue(10)), 100),
    curr: optional(picklist([
      "nztoken", "autoken", "sgtoken", "catoken", "gbtoken", "ustoken", "eutoken", "aetoken", "iltoken", "mxtoken", "hktoken", "cntoken", "nzarrears", "auarrears", "usarrears",
    ] as const satisfies readonly NonNullable<TokenCurrency>[])),
  }),
  beforeLoad: () => ({
    breadcrumb: "Transactions",
  }),
  head: () => ({ meta: seo({ title: "Wallet" }) }),
});
